import { SesionAdmin } from '../types/identidad';

/**
 * Sesion administrativa (Functional Design, Pregunta 7): localStorage.
 * Riesgo de exposicion ante XSS aceptado explicitamente por el usuario — ver
 * aidlc-docs/construction/frontend-web-app/functional-design/business-logic-model.md.
 */
const CLAVE = 'sacrafts_admin_session';

export function guardarSesion(sesion: SesionAdmin): void {
  window.localStorage.setItem(CLAVE, JSON.stringify(sesion));
}

export function obtenerSesion(): SesionAdmin | null {
  const crudo = window.localStorage.getItem(CLAVE);
  if (!crudo) return null;
  try {
    return JSON.parse(crudo) as SesionAdmin;
  } catch {
    return null;
  }
}

export function limpiarSesion(): void {
  window.localStorage.removeItem(CLAVE);
}
